// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"ee3f28bb","453":"049b0ae9","667":"42b1ab9a"}[chunkId] + ".chunk.js";
};